
	<template>
			<div class="page-bg" :style="{ backgroundImage: `url(${ showHeroBg ? heroBgResponsive : heroBg })` }">

		<!-- HERO -->
		<section class="hero">
			<div class="container">
				<h1>
					Maximiza la rentabilidad de<br>
					tu propiedad en Chile.
				</h1>

				<p class="hero-text">
					Property Management para propietarios e inversionistas: tú recibes
					el 75% del ingreso neto y nosotros operamos el activo de punta a punta.
				</p>

				<a href="#" @click.prevent="openWhatsApp" class="btn-primary steps-btn" target="_blank" rel="noopener">
					→ SOLICITAR EVALUACIÓN GRATUITA
				</a>
			</div>
		</section>

		<!-- BENEFICIOS -->
		<section class="benefits">
			<div class="container">
				<h2 class="fade-block" :style="{ transitionDelay: '160ms' }">
					<b>Optimización de NOI vía flexibilidad de renta<br>
					+<span class="percent">{{ percent }}</span>% vs renta tradicional · 0 honorarios fijos</b>
				</h2>

				<div class="columns">
					<div class="column">
						<h3>Este servicio es para ti si:</h3>
						<ul>
							<li>Buscas aumentar la rentabilidad.</li>
							<li>Quieres delegar la operación diaria.</li>
							<li>Quieres mejorar la experiencia de tus huéspedes.</li>
							<li>Valoras el control financiero.</li>
						</ul>
					</div>

					<div class="column">
						<h3>Nos ocupamos de la gestión integral de tu propiedad:</h3>
						<ul>
							<li>Maximizamos ingresos con pricing y ocupación dinámica.</li>
							<li>Operamos el activo, sin gestión para el propietario.</li>
							<li>
								Entregamos control financiero claro, con reportes mensuales
								y pagos a tiempo.
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<!-- PASOS -->
		<section class="steps">
			<div class="container steps-container">
				<h2 class="steps-title">EMPIEZA EN 4 SIMPLES PASOS:</h2>

				<div class="steps-list">
					<div
						class="step-item fade-block"
						v-for="(step, index) in steps"
						:key="step.number"
						:style="{ transitionDelay: (220 + index * 120) + 'ms' }"
					>
						<div class="step-number">{{ step.number }}</div>
						<p>{{ step.text }}</p>
					</div>
				</div>

				<a href="#" @click.prevent="openWhatsApp" class="btn-primary steps-btn" target="_blank" rel="noopener">
					→ SOLICITAR EVALUACIÓN GRATUITA
				</a>
			</div>
		</section>

		<!-- FOOTER -->
		<section class="footer-info">
			<div class="container">
				<p><b>No administramos propiedades.<br>Operamos activos inmobiliarios.</b></p>

				<p>
					Nuestro modelo combina demanda real, operación profesional y control
					financiero para maximizar el rendimiento de cada unidad.
				</p>

				<p class="highlight">
					Recibe una proyección de rentabilidad y modelo recomendado
					en menos de 24 horas.
				</p>

				<!-- <div class="contact-icons">
					<span>✉</span>
					<span>🟢</span>
				</div> -->
			</div>
		</section>

	</div>
</template>

<script>
import heroBg from '@/assets/property.png';
import heroBgResponsive from '@/assets/property_responsive.png';

export default {
	name: "PropertyManagement",
	data() {
		return {
			steps: [
				{ number: 1, text: "EVALUACIÓN DEL ACTIVO" },
				{ number: 2, text: "ESTRATEGIA DE RENTA ÓPTIMA" },
				{ number: 3, text: "IMPLEMENTACIÓN Y OPERACIÓN" },
				{ number: 4, text: "REPORTE Y PAGO MENSUAL" }
			]
			,
			entered: false,
			percent: 0,
			percentTarget: 15,
			heroBg,
			heroBgResponsive,
			showHeroBg: false,
			_mediaQuery: null
		};
	},
	methods: {
		handleMq(e) {
			this.showHeroBg = e.matches;
		},
		openWhatsApp() {
			const text = 'Hola, necesito ayuda con...';
			const url = 'https://api.whatsapp.com/send/?phone=56926318852&text=' + encodeURIComponent(text);
			window.open(url, '_blank');
		}
		,
		animatePercent(duration = 1200) {
			const start = performance.now();
			const from = 0;
			const to = this.percentTarget;

			const easeOutQuad = (t) => t * (2 - t);

			const step = (now) => {
				const elapsed = now - start;
				const t = Math.min(1, elapsed / duration);
				this.percent = Math.floor(from + (to - from) * easeOutQuad(t));
				if (t < 1) requestAnimationFrame(step);
				else this.percent = to;
			};

			requestAnimationFrame(step);
		}
	}
	,
	mounted() {
		// trigger entry animations and the percent counter
		requestAnimationFrame(() => {
			this.entered = true;
			this.animatePercent();
		});

		// responsive background: show only on mobile/tablet
		if (typeof window !== 'undefined' && window.matchMedia) {
			this._mediaQuery = window.matchMedia('(max-width: 1024px)');
			this.showHeroBg = this._mediaQuery.matches;
			this._mediaQuery.addListener(this.handleMq);
		}
	},
	beforeDestroy() {
		if (this._mediaQuery && this._mediaQuery.removeListener) {
			this._mediaQuery.removeListener(this.handleMq);
		}
	}
};

</script>

<style scoped>
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	font-family: Arial, sans-serif;
	color: black;
}

body {
	background: #ffffff;
	line-height: 1.5;
}

.container {
	max-width: 1100px;
	margin: auto;
	padding: 60px 20px;
	text-align: center;
}

/* HERO */
.hero h1 {
	font-size: 48px;
	font-weight: 700;
	margin-bottom: 30px;
}

.hero {
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	color: #ffffff;
}

.page-bg {
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	min-height: 100vh;
}

.hero {
	background: transparent;
}

.hero-text {
	font-size: 18px;
	max-width: 650px;
	margin: 0 auto 80px;
}

/* BOTÓN */
.btn-primary {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: #ff7a00;
	color: #fff;
	padding: 18px 36px;
	border-radius: 999px;
	text-decoration: none;
	font-weight: 700;
	font-size: 16px;
	transition: all 0.3s ease;
}

.btn-primary:hover {
	background: #e96f00;
	transform: translateY(-3px);
	box-shadow: 0 8px 20px rgba(255, 122, 0, 0.35);
}
/* BENEFICIOS — ESCALADO PRO */

.benefits h2 {
	font-size: 38px;          /* antes 26 */
	margin-bottom: 90px;     /* más aire */
	font-weight: 800;
	line-height: 1.25;
}

.columns {
	display: flex;
	justify-content: center;
	gap: 120px;              /* antes 80 */
	max-width: 1100px;       /* más ancho */
	margin: 0 auto;
	align-items: flex-start;
}

.column {
	width: 460px;            /* antes 360 */
	text-align: left;
}

.column h3 {
	margin-bottom: 26px;
	font-weight: 600;
	font-size: 22px;         /* antes 16 */
}

.column ul {
	padding-left: 24px;
}

.column li {
	margin-bottom: 18px;     /* más aire entre bullets */
	font-size: 20px;         /* antes ~16 */
	line-height: 1.6;
}

/* PASOS */
.steps-container {
	max-width: 465px;
}

.steps-title {
	font-size: 26px;
	margin-bottom: 50px;
	font-weight: 800; /* ← agregado */
}
.steps-list {
	display: flex;
	flex-direction: column;
	gap: 28px;
}

.step-item {
	display: flex;
	align-items: center;
	gap: 24px;
}

.step-number {
	width: 56px;
	height: 56px;
	border: 2px solid #ff7a00;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #ff7a00;
	font-size: 26px;
	font-weight: 700;
}

.step-item p {
	font-size: 18px;
	font-weight: 700;
	text-align: left;
}

.steps-btn {
	display: block;
	margin: 50px auto 0;
	max-width: 420px;
	width: 100%;
}

/* FOOTER */
.footer-info {
	font-weight: 800;
	font-size: 18px;
}

.footer-info p {
	max-width: 800px;
	margin: 0 auto 20px;
	font-size: 20px;
}


.highlight {
	font-weight: 600;
}

.contact-icons {
	font-size: 32px;
	display: flex;
	justify-content: center;
	gap: 20px;
}

@media (max-width: 768px) {
	.columns {
		flex-direction: column;
		gap: 50px;
	}

	.benefits h2 {
		font-size: 26px;
		margin-bottom: 50px;
	}

	.column {
		width: 100%;
	}

	.column h3 {
		font-size: 18px;
	}

	.column li {
		font-size: 16px;
	}
}
</style>
